import { Injectable } from '@angular/core';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private serviceID = 'service_l171d4p';
  private templateID = 'template_wepigv9';
  private publicKey = 'EW7FuLifrm6sneKDo';

  constructor() {}

   sendEmail(formData: { to_name: string; reply_to: string | string[]; body: string; subject: string }) {
    if (Array.isArray(formData.reply_to)) {
      // If multiple emails, send to each one
      const promises = formData.reply_to.map(email =>
        emailjs.send(
          this.serviceID,
          this.templateID,
          {
            to_name: formData.to_name,
            reply_to: email,   // 👈 send individually
            body: formData.body,
            subject: formData.subject,
          },
          this.publicKey
        )
      );
      return Promise.all(promises); // resolve when all emails are sent
    } else {
      // Single email
      return emailjs.send(
        this.serviceID,
        this.templateID,
        {
          to_name: formData.to_name,
          reply_to: formData.reply_to,
          body: formData.body,
          subject: formData.subject,
        },
        this.publicKey
      );
    }
  }


  private decodeHtmlEntities(text: string): string {
  const txt = document.createElement('textarea');
  txt.innerHTML = text;
  return txt.value;
}

}
